import { JSONLD } from 'lincd-jsonld/utils/JSONLD';
import { createNameSpace } from 'lincd/utils/NameSpace';
import { linkedOntology } from '../package.js';
//finally, we pass on all the exports, plus the namespace, prefix and data loading function
// as we register this ontology in the LINCD tree
import * as _this from './sioc.js';
export var loadData = () => {
    if (typeof module !== 'undefined' && typeof exports !== 'undefined') {
        // CommonJS import
        return import('../data/sioc.json').then((data) => JSONLD.parse(data));
    }
    else {
        // ESM import
        //@ts-ignore
        return import('../data/sioc.json', { with: { type: 'json' } }).then((data) => JSONLD.parse(data.default));
    }
};
export var ns = createNameSpace('http://rdfs.org/sioc/ns#');
//It's recommended to export a NamedNode for the ontology itself as well
export var _self = ns('');
//The main goal though of this file is to export a reference to NamedNode with the correct URI
// for all the entities (Classes and properties) in the ontology
export var Container = ns('Container');
export var Item = ns('Item');
export var Role = ns('Role');
export var Site = ns('Site');
export var Space = ns('Space');
export var UserAccount = ns('UserAccount');
export var Usergroup = ns('Usergroup');
export var about = ns('about');
export var account_of = ns('account_of');
export var avatar = ns('avatar');
export var email = ns('email');
export var has_creator = ns('has_creator');
export var has_function = ns('has_function');
export var has_member = ns('has_member');
export var has_scope = ns('has_scope');
export var has_usergroup = ns('has_usergroup');
export var id = ns('id');
export var links_to = ns('links_to');
export var member_of = ns('member_of');
export var name = ns('name');
export var usergroup_of = ns('usergroup_of');
export var has_owner = ns('has_owner');
export const sioc = {
    Container,
    Item,
    Role,
    Site,
    Space,
    UserAccount,
    Usergroup,
    about,
    account_of,
    avatar,
    email,
    has_creator,
    has_function,
    has_member,
    has_owner,
    has_scope,
    has_usergroup,
    id,
    links_to,
    member_of,
    name,
    usergroup_of,
};
//as third parameter, provide a prefix (string) that can be used to refer to the full ontology URL.
//for example: 'schema' refers to https://www.schema.org/
linkedOntology(_this, ns, 'sioc', loadData, '../data/sioc.json');
//# sourceMappingURL=sioc.js.map